import { Instance, SnapshotIn, SnapshotOut, types } from "mobx-state-tree"

export const RoomGuestModel = types.model("RoomGuest").props({
  id: types.identifier,
  userId: types.maybeNull(types.string),
  profileId: types.maybeNull(types.number),
  firstName: types.string,
  lastName: types.string,
  ageGroup: types.string,
  email: types.string,
  phoneNumber: types.string,
  dob: types.optional(types.string, ""),
  avatar: types.maybeNull(types.string),
})

export type RoomGuest = Instance<typeof RoomGuestModel>
export type RoomGuestSnapshotOut = SnapshotOut<typeof RoomGuestModel>
export type RoomGuestSnapshotIn = SnapshotIn<typeof RoomGuestModel>
